/*
 * @Author: Teemo Ding
 * @Date: 2022-01-30 13:29:05
 * @LastEditTime: 2022-01-30 13:54:00
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/disable.tsx
 */
import React from 'react';
import { Icon } from '@/src/tools/icon';
import styles from './css.module.less';

const Disable = () => {
  return (
    <div className={styles.previous}>
      <Icon type='iconinfo2' className={styles.infoIcon} />
      <p>
        Previous content page is not editable. Please go back to page list to
        duplicate or delete this page.
      </p>
    </div>
  );
};

export default Disable;
